/**
 * 格式化时间戳
 * @param {*} time 时间戳 13位或10位
 * @param {*} cut 分割符 -或/  汉字拼接传“年”
 * @param {*} flag 时间的时分秒是否需要 默认需要
 */
const formatDate = (time, cut = "-", flag = true) => {
  if (!time) return "--";
  // 处理10位时间戳
  time = time.toString().length > 10 ? time : time * 1000;
  let date = new Date(time);
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  let d = date.getDate();
  let h = date.getHours();
  let mm = date.getMinutes();
  let s = date.getSeconds();

  let hours = flag
    ? " " + addZero(h) + ":" + addZero(mm) + ":" + addZero(s)
    : "";
  if (cut == "-" || cut == "/") {
    return y + cut + addZero(m) + cut + addZero(d) + hours;
  } else if (cut == "年") {
    return y + "年" + addZero(m) + "月" + addZero(d) + "日" + hours;
  }
};

/**
 * 金额处理 eg: 1,230,222.02
 * @param {*} number 要格式化的金额  单位分
 * @param {*} decimals 保留几位小数
 * @param {*} thousands_sep 千分位符号
 */
const formatMoney = (number, decimals = 2, thousands_sep = ",") => {
  number = (number + "").replace(/[^0-9+-Ee.]/g, "");
  let n = number ? toFixed(number / 100, decimals) : 0; //金额为分
  let s = n.split(".");

  let re = /\B(?=(\d{3})+(?!\d))/g;
  if (re.test(s[0])) {
    s[0] = s[0].replace(re, thousands_sep);
  }
  return s.join(".");
};

/**
 * 保留小数位
 * @param {*} number 需要保留的数字
 * @param {*} fractionDigits 小数位数
 */
const toFixed = (number, fractionDigits = 2) => {
  let times = Math.pow(10, fractionDigits);
  let roundNum = Math.round(number * times) / times;
  return roundNum.toFixed(fractionDigits);
};

/**
 * 深拷贝
 * @param {*} target 拷贝对象
 */
const deepClone = target => {
  // 如果当前需要深拷贝的不是一个对象的话
  if (typeof target === "object") return target;

  let result;
  if (Array.isArray(target)) {
    result = [];
    for (let i in target) {
      // 递归克隆数组中的每一项
      let item =
        typeof target[i] === "object" ? deepClone(target[i]) : target[i];
      result.push(item);
    }
  } else if (target === null) {
    result = null;
  } else if (target.constructor === RegExp) {
    result = target;
  } else {
    // 否则是普通对象，直接for in循环，递归赋值对象的所有值
    result = {};
    for (let i in target) {
      let item =
        typeof target[i] === "object" ? deepClone(target[i]) : target[i];
      result[i] = deepClone(item);
    }
  }
  return result;
};

// 补0函数
const addZero = value => {
  return value < 10 ? "0" + value : value;
};

// px转vw
const vm_base = 750; // 基础尺寸
const reg = /px$/i;
const px2vw = px => {
  if (type(px) === "number") {
    return `${(px / vm_base) * 100}vw`;
  }

  if (!isNaN(Number(px))) {
    return `${(px / vm_base) * 100}vw`;
  }

  if (reg.test(px)) {
    return `${(px.slice(0, -2) / vm_base) * 100}vw`;
  }
  console.warn("Incorrect parameter");
};

// 类型判断函数
const type = o => {
  var s = Object.prototype.toString.call(o);
  // 可能返回的类型
  // type({}); // "object"
  // type([]); // "array"
  // type(5); // "number"
  // type(null); // "null"
  // type(); // "undefined"
  // type(/abcd/); // "regex"
  // type(new Date()); // "date"
  // type(new Map()); // "map"
  // type(new Set()); // "set"
  // type(Symbol()); // "symbol"
  return s.match(/\[object (.*?)\]/)[1].toLowerCase();
};

// 防抖(触发高频事件后n秒内函数只会执行一次，如果n秒内高频事件再次被触发，则重新计算时间)
const debounce = (fn, delay = 200) => {
  let timeout = null; // 创建一个标记用来存放定时器的返回值
  return function() {
    clearTimeout(timeout); // 每当用户输入的时候把前一个 setTimeout clear 掉
    timeout = setTimeout(() => {
      // 然后又创建一个新的 setTimeout, 这样就能保证输入字符后的 interval 间隔内如果还有字符输入的话，就不会执行 fn 函数
      fn.apply(this, arguments);
    }, delay);
  };
};

// 节流(高频事件触发，但在n秒内只会执行一次，所以节流会稀释函数的执行频率)
const throttle = (fn, delay = 200) => {
  let flag = true; // 通过闭包保存一个标记
  return function() {
    if (!flag) return; // 在函数开头判断标记是否为true，不为true则return
    flag = false; // 立即设置为false
    setTimeout(() => {
      // 将外部传入的函数的执行放在setTimeout中
      fn.apply(this, arguments);
      // 最后在setTimeout执行完毕后再把标记设置为true(关键)表示可以执行下一次循环了。当定时器没有执行的时候标记永远是false，在开头被return掉
      flag = true;
    }, delay);
  };
};

export { formatDate, formatMoney, deepClone, px2vw, type, debounce, throttle };
